
import React from 'react';
import { Skeleton } from '@/components/ui/skeleton';

const WarehouseInspectionSkeleton: React.FC = () => {
  return (
    <div className="space-y-6">
      <Skeleton className="h-12 w-3/4" />
      <Skeleton className="h-64 w-full" />
    </div>
  );
};

export default WarehouseInspectionSkeleton;
